// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ccZiQ","colMin":"styles_colMin__2f_wI"};